import CapabilityInfoModal from './CapabilityInfoModal';

export default CapabilityInfoModal;
